import React from "react";
import { useNavigate } from "react-router-dom";

const ProductShowcase = () => {
  const navigate = useNavigate();

  // 1. Added a "navLink" property to each product object
  const products = [
    {
      id: 1,
      image: require("../../../assets/images/home/home1.png"),
      category: "BAGS",
      title: "Premium Backpack Collection",
      description: "Stylish and functional bags for modern professionals",
      navLink: "/bags", // Navigation path for this item
    },
    {
      id: 2,
      image: require("../../../assets/images/home/home3.png"),
      category: "LUGGAGE",
      title: "Travel Essentials",
      description: "Durable luggage for your adventures",
      navLink: "/luggage", // Navigation path for this item
    },
    {
      id: 3,
      image: require("../../../assets/images/home/home2.png"),
      category: "BACKPACKS",
      title: "Urban Backpacks",
      description: "Perfect for city life and daily commutes",
      navLink: "/backpacks", // Navigation path for this item
    },
  ];

  // 2. The handler now takes the entire link as an argument
  const handleCardClick = (link) => {
    if (link) {
      navigate(link);
    }
  };

  return (
    <div className="bg-white py-8 px-4">
      <div className="mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {products.map((product) => (
            <div
              key={product.id}
              className="group relative bg-white overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer transform hover:-translate-y-2"
              // 3. Pass the product's specific navLink to the handler
              onClick={() => handleCardClick(product.navLink)}
            >
              {/* Product Image */}
              <div className="relative overflow-hidden">
                <img
                  src={product.image}
                  alt={product.title}
                  className="w-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300"></div>
              </div>
              {/* Product Details */}
              <div className="absolute bottom-2 left-2 right-2">
                <div className="bg-white bg-opacity-90 backdrop-blur-sm rounded-md px-3 py-2">
                  <h3 className="font-bold text-sm text-gray-800 tracking-wider">
                    {product.category}
                  </h3>
                  <p className="text-xs text-gray-600 mt-1">
                    {product.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductShowcase;